/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Right_LabelInputs */

const en_diff_right_label = /** @type {(inputs: Diff_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right (Modified)`)
};

const ko_diff_right_label = /** @type {(inputs: Diff_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오른쪽 (수정본)`)
};

const ja_diff_right_label = /** @type {(inputs: Diff_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右（変更後のJSON）`)
};

/**
* | output |
* | --- |
* | "Right (Modified)" |
*
* @param {Diff_Right_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_right_label = /** @type {((inputs?: Diff_Right_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Right_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_right_label(inputs)
	if (locale === "ko") return ko_diff_right_label(inputs)
	return ja_diff_right_label(inputs)
});